import { forwardRef, lazy, Suspense } from "react";
import { TransitionProps } from "@mui/material/transitions";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  useTheme,
  CircularProgress,
  Box,
  IconButton,
} from "@mui/material";
// hooks
import useAuth from "~src/hooks/useAuth";
// components
import Iconify from "~src/components/Iconify";

// Lazy load the Plans component
const Plans = lazy(() => import("~src/pages/settings/Plans"));

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function NoSubscriptionPopup({ open }: { open: boolean }) {
  const theme = useTheme();
  const { logout } = useAuth();

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
      onClose={() => {}}
      fullScreen={window.innerWidth < theme.breakpoints.values.sm}
      disableEscapeKeyDown
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "100%",
        },
        [theme.breakpoints.up("md")]: { px: 4 },
        [theme.breakpoints.down("sm")]: { px: 1 },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          position: "relative",
        }}
        variant="h4"
      >
        {"You need an Active Subscription plan to use TrendRocket"}
        <IconButton
          aria-label="logout"
          onClick={logout}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Iconify icon={"iconamoon:close-thin"} width={40} height={40} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          sx={{ textAlign: "center", mb: 2 }}
        >
          Choose a plan to continue.
        </DialogContentText>
        <Suspense fallback={
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        }>
          <Plans />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
}
